import React from 'react';
import { toImmutable, Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import TermUtils from 'utils/terms';
import GrowthGoalUtils from '../utils';

import DropdownMenu from 'components/generic/controls/dropdown-menu';
import GoalSettingForm from './goal-setting-form';
import Chart from './chart';
import CGIWarning from './conditional-growth-index-warning';

export default CreateReactClass({
    displayName: 'GoalSettingSection',

    propTypes: {
        clearDirtyDataFlag: PropTypes.func.isRequired,
        currentTerm: PropTypes.instanceOf(Immutable.Map),
        dropdownTermNumber: PropTypes.number,
        firstOpenTerm: PropTypes.instanceOf(Immutable.Map),
        goalSettingTerms: PropTypes.instanceOf(Immutable.List).isRequired,
        growthGoals: PropTypes.instanceOf(Immutable.List),
        growthGoalNorms: PropTypes.instanceOf(Immutable.Map),
        growthGoalNormsLoaded: PropTypes.bool,
        growthGoalsExpanded: PropTypes.bool,
        growthProjections: PropTypes.instanceOf(Immutable.List),
        growthProjectionsLoaded: PropTypes.bool,
        highlightTerm: PropTypes.func.isRequired,
        keystoneTestEvent: PropTypes.object,
        linkingStudiesData: PropTypes.object,
        linkingStudiesLoaded: PropTypes.bool,
        maxTestEvent: PropTypes.instanceOf(Immutable.Map),
        ritQuintiles: PropTypes.instanceOf(Immutable.Map),
        ritQuintilesLoaded: PropTypes.bool,
        setDirtyDataFlag: PropTypes.func.isRequired,
        showGoalAlreadySetModal: PropTypes.func.isRequired,
        showGoalSettingFailedModal: PropTypes.func.isRequired,
        showSaveDataPrompt: PropTypes.func.isRequired,
        startingTerm: PropTypes.instanceOf(Immutable.Map),
        studentBid: PropTypes.string.isRequired,
        studentTermData: PropTypes.instanceOf(Immutable.List).isRequired,
        subject: PropTypes.instanceOf(Immutable.Map).isRequired,
        terms: PropTypes.instanceOf(Immutable.List),
        testEvents: PropTypes.instanceOf(Immutable.List).isRequired,
        testToProjectFromForCurrentTerm: PropTypes.instanceOf(Immutable.Map),
        unHighlightTerm: PropTypes.func.isRequired,
        unsavedDataState: PropTypes.instanceOf(Immutable.Map).isRequired,
        upcomingGoalsId: PropTypes.string,
    },

    getInitialState() {
        return {
            targetTermNumber: null,
            cgiWarningDismissedYn: false,
            cgiWarningMessage: null,
            growthGoalsCurrentRit: null,
        };
    },

    UNSAFE_componentWillMount() {
        if (this.props.goalSettingTerms && !this.props.goalSettingTerms.isEmpty()) {
            this.setState({ targetTermNumber: this.props.goalSettingTerms.first().get('termNumber') });
        }
    },

    UNSAFE_componentWillReceiveProps(nextProps) {
        const dataCleared =
            nextProps.unsavedDataState &&
            this.props.unsavedDataState &&
            !nextProps.unsavedDataState.get('unsavedData') &&
            this.props.unsavedDataState.get('unsavedData');

        // reinitialize the term if student changed
        if (nextProps.studentBid !== this.props.studentBid) {
            this.reinitialize(nextProps);
        } else if (dataCleared) {
            // if unsavedData flag cleared, check to see if the term dropdown cleared it...if so, do not re-initialize term
            const skipTermInitialization = nextProps.unsavedDataState.get('modifier') === this.growthGoalTermDropdown;
            this.reinitialize(nextProps, skipTermInitialization);
        } else if (nextProps.dropdownTermNumber && !this.props.growthGoalsExpanded && nextProps.growthGoalsExpanded) {
            //If we are entering the expanded Growth Goals Module, determine the initial term from the runtime store.
            this.changeTerm(nextProps.dropdownTermNumber);
        }
    },

    growthGoalTermDropdown: 'growth-goal-term-dropdown',

    updateCurrentRit(currentRit) {
        if (!!currentRit) {
            this.setState({
                growthGoalsCurrentRit: currentRit,
            });
        }
    },

    changeTerm(termNumber) {
        const updateState = () => {
            this.setState({
                targetTermNumber: parseInt(termNumber),
                cgiWarningMessage: null,
            });
        };

        if (this.props.unsavedDataState.get('unsavedData')) {
            this.props
                .showSaveDataPrompt()
                .then(() => {
                    updateState();
                    this.props.clearDirtyDataFlag(this.growthGoalTermDropdown); // mark that the term dropdown cleared the flag
                })
                .catch(() => {
                    /* do nothing */
                });
        } else {
            updateState();
        }
    },

    reinitialize(props = this.props, skipTermInitialization = false) {
        const newState = {
            cgiWarningDismissedYn: false,
            cgiWarningMessage: null,
        };
        if (!skipTermInitialization) {
            const targetTermNumber = props.goalSettingTerms.isEmpty()
                ? null
                : props.goalSettingTerms.first().get('termNumber');
            newState.targetTermNumber = targetTermNumber;
        }

        this.setState(newState);
    },

    //<editor-fold desc="cgi warning functions">
    dismissCgiWarning() {
        this.setState({
            cgiWarningDismissedYn: true,
        });
    },

    clearCgiWarnings() {
        this.setState({
            cgiWarningDismissedYn: false,
            cgiWarningMessage: null,
        });
    },

    setCgiWarningMessage(message) {
        this.setState({
            cgiWarningMessage: message,
        });
    },
    //</editor-fold>

    renderTab() {
        // for now, just the custom goal tab
        return (
            <div id={`custom-goal-tab`} key="custom-goal-tab" className="custom-goal-tab">
                <p key="custom-goal-text" className="tab-title">
                    CUSTOM GOAL
                </p>
            </div>
        );
    },

    renderCGIWarning() {
        return (
            <CGIWarning
                key="cgi-warning"
                message={this.state.cgiWarningMessage}
                dismissedYn={this.state.cgiWarningDismissedYn}
                onDismiss={this.dismissCgiWarning}
            />
        );
    },

    render() {
        const defaultOption =
            this.props.goalSettingTerms && !this.props.goalSettingTerms.isEmpty()
                ? TermUtils.textFromTermNumber(this.props.goalSettingTerms.first().get('termNumber'), true)
                : '';
        const termDropdown = (
            <DropdownMenu
                id={`goal-term-dropdown`}
                key="goal-setting-term-dropdown"
                selectedOptionValue={this.state.targetTermNumber}
                defaultOption={defaultOption}
                onChange={this.changeTerm}
                label="Set a goal for: "
                optionList={this.props.goalSettingTerms}
                elementValueFunction={(term) => term.get('termNumber')}
                elementDisplayFunction={(term) => TermUtils.textFromTermNumber(term.get('termNumber'), true)}
                classesDivWrapper="dropdown"
            />
        );

        const previousRitScore = GrowthGoalUtils.findPreviousRitScore(
            this.props.maxTestEvent,
            this.props.firstOpenTerm
        );
        const cgiWarning = this.renderCGIWarning();
        const growthProjections = GrowthGoalUtils.findTypicalGrowthForTargetTerm(
            this.props.growthProjections,
            this.state.targetTermNumber
        );
        const unsavedData = this.props.unsavedDataState ? this.props.unsavedDataState.get('unsavedData') : false;
        return (
            <div className="goal-setting-section">
                {termDropdown}
                {this.renderTab()}
                {cgiWarning}
                <GoalSettingForm
                    key="goal-setting-form"
                    studentBid={this.props.studentBid}
                    growthGoalYn={!!previousRitScore}
                    previousRitScore={previousRitScore}
                    typicalGrowth={growthProjections.typicalGrowth}
                    percentileIfMet={growthProjections.percentileIfMet}
                    ritQuintilesLoaded={this.props.ritQuintilesLoaded}
                    typicalScore={GrowthGoalUtils.findTypicalScore(
                        this.props.ritQuintiles,
                        this.state.targetTermNumber,
                        this.props.subject,
                        this.props.studentTermData
                    )}
                    targetTermNumber={this.state.targetTermNumber}
                    startingTerm={this.props.startingTerm}
                    growthGoals={this.props.growthGoals}
                    studentTermData={this.props.studentTermData}
                    goalSettingTerms={this.props.goalSettingTerms}
                    growthGoalNorms={this.props.growthGoalNorms}
                    growthGoalNormsLoaded={this.props.growthGoalNormsLoaded}
                    subject={this.props.subject}
                    setCgiWarningMessage={this.setCgiWarningMessage}
                    clearCgiWarnings={this.clearCgiWarnings}
                    highlightTerm={this.props.highlightTerm}
                    unHighlightTerm={this.props.unHighlightTerm}
                    maxTestEvent={this.props.maxTestEvent}
                    showGoalAlreadySetModal={this.props.showGoalAlreadySetModal}
                    showGoalSettingFailedModal={this.props.showGoalSettingFailedModal}
                    reinitialize={this.reinitialize}
                    setDirtyDataFlag={this.props.setDirtyDataFlag}
                    clearDirtyDataFlag={this.props.clearDirtyDataFlag}
                    unsavedData={unsavedData}
                    currentRitForSubject={parseInt(this.state.growthGoalsCurrentRit)}
                    updateCurrentRit={this.updateCurrentRit}
                    upcomingGoalsId={this.props.upcomingGoalsId}
                />
                <Chart
                    key="goal-setting-chart"
                    subject={this.props.subject}
                    maxTestEvent={this.props.maxTestEvent}
                    firstOpenTerm={this.props.firstOpenTerm}
                    studentTermData={this.props.studentTermData}
                    growthGoalYn={!!previousRitScore}
                    targetTermNumber={this.state.targetTermNumber}
                    currentTerm={this.props.currentTerm}
                    testToProjectFromForCurrentTerm={this.props.testToProjectFromForCurrentTerm}
                    growthProjections={this.props.growthProjections}
                    growthProjectionsLoaded={this.props.growthProjectionsLoaded}
                    ritQuintiles={this.props.ritQuintiles}
                    ritQuintilesLoaded={this.props.ritQuintilesLoaded}
                    testEvents={this.props.testEvents}
                    goalSettingTerms={this.props.goalSettingTerms}
                    currentRitForSubject={parseInt(this.state.growthGoalsCurrentRit)}
                    studentBid={this.props.studentBid}
                    terms={this.props.terms}
                    growthGoals={this.props.growthGoals}
                    linkingStudiesData={this.props.linkingStudiesData}
                    linkingStudiesLoaded={this.props.linkingStudiesLoaded}
                    keystoneTestEvent={this.props.keystoneTestEvent}
                />
            </div>
        );
    },
});
